export default __webpack_public_path__ + "static/media/mike.c019d5cf.png";